import { render, staticRenderFns } from "./StatOverlay.vue?vue&type=template&id=b303cb7a&"
import script from "./StatOverlay.vue?vue&type=script&lang=js&"
export * from "./StatOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports